module.exports = __webpack_public_path__ + "img/20220521_ust_depeg.7fddb828.png";